import React, {FC, useMemo} from "react";
import {Typography} from "@components/Typography";
import {FormattedMessage} from "react-intl";
import {ParamsTable} from "@components/ParamsTable";
import {Section} from "@components/Section";
import {entries} from "../../types/general";

const params: Record<string, {label: React.ReactElement, show: (data: Record<string, any>) => boolean, value: (data: Record<string, any>) => React.ReactElement}> = {
    nazev: {
        label: <FormattedMessage defaultMessage={"Název"} />,
        show: (data) => !!data.nazev,
        value: (data) => data.www ? (
            <a href={data.www}>{data.nazev}</a>
        ) : data.nazev,
    },
    kapacita: {
        label: <FormattedMessage defaultMessage={"Kapacita"} />,
        show: (data) => !!data.kapacita,
        value: (data) => data.kapacita,
    },
    loznice: {
        label: <FormattedMessage defaultMessage={"Ložnice"} />,
        show: (data) => !!data.loznice,
        value: (data) => data.loznice,
    },
    detska_postylka: {
        label: <FormattedMessage defaultMessage={"Dětská postýlka"} />,
        show: (data) => !!data.detska_postylka,
        value: (data) => data.detska_postylka,
    },
    mesto: {
        label: <FormattedMessage defaultMessage={"Město"} />,
        show: (data) => !!data.mesto,
        value: (data) => data.mesto_url ? (
            <a href={data.mesto_url}>{data.mesto}</a>
        ) : data.mesto,
    },
    krb: {
        label: <FormattedMessage defaultMessage={"Krb"} />,
        show: (data) => !!data.krb,
        value: (data) => data.krb,
    },
    wifi: {
        label: <FormattedMessage defaultMessage={"Wifi"} />,
        show: (data) => !!data.wifi,
        value: (data) => data.wifi,
    },
    bazen: {
        label: <FormattedMessage defaultMessage={"Bazén"} />,
        show: (data) => !!data.bazen,
        value: (data) => data.bazen,
    },
    sauna: {
        label: <FormattedMessage defaultMessage={"Sauna"} />,
        show: (data) => !!data.sauna,
        value: (data) => data.sauna,
    },
    virivka: {
        label: <FormattedMessage defaultMessage={"Vířivka"} />,
        show: (data) => !!data.virivka,
        value: (data) => data.virivka,
    },
    pes_povolen: {
        label: <FormattedMessage defaultMessage={"Pes povolen"} />,
        show: (data) => !!data.pes_povolen,
        value: (data) => data.pes_povolen,
    },
}

export const EChalupyParameters: FC<{data: string}> = ({data}) => {
    const parsed = useMemo(() => JSON.parse(data),[data]);

    const filtered = entries(params).filter(([_, {show}]) => show(parsed));

    return (
        <Section className="mb-5 mb-lg-10">
            <Typography as="h2" className="mb-3 mb-lg-8" variant="subheadline">
                <FormattedMessage defaultMessage={'Parametry nemovitosti'} />
            </Typography>
            <ParamsTable>
                <ParamsTable.Group>
                    <table>
                        <tbody>
                        {filtered
                            .filter((_, idx) => idx % 2 === 0)
                            .map(([key, {label, value}]) => (
                                <tr id={key}>
                                    <th>{label}</th>
                                    <td>
                                        {value(parsed)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ParamsTable.Group>
                <ParamsTable.Group>
                    <table>
                        <tbody>
                        {filtered
                            .filter((_, idx) => idx % 2 === 1)
                            .map(([key, {label, value}]) => (
                                <tr id={key}>
                                    <th>{label}</th>
                                    <td>
                                        {value(parsed)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ParamsTable.Group>
            </ParamsTable>
        </Section>
    );
}
